import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type ThisApi = ApiDefinition['/filing-review/configs/{id}']['PUT'];
type Input = ThisApi['params'] & ThisApi['body'];
type Output = ThisApi['response'];

const updateConfig = async ({ id, ...body }: Input): Promise<Output> => {
  const path = buildPath<ThisApi>('/filing-review/configs/{id}', { id });
  const response = await noodleApiClient.put(path, body);
  return response.data;
};

export default updateConfig;
